import axios from "../instance";

export default {
    getAll: (companyId) => {
        return axios.api.get(`/discountModels?companyId=${companyId}`).then((response) => response.data);
    },
    getAllbyPrioriity: (priority) => {
        return axios.api.get(`/discountModels?priority=${priority}`).then((response) => response.data);
    },
    getOne: (id) => {
        return axios.api.get(`/discountModels/${id}`).then((response) => response.data);
    },
    search: (body) => {
        return axios.api.post("/discountModels/search", body).then((response) => response.data);
    },
    create: (body) => {
        return axios.api.post("/discountModels", body).then((response) => response.data);
    },
    update: (id, body) => {
        return axios.api.put(`/discountModels/${id}`, body).then((response) => response.data);
    },
    delete: (id) => {
        return axios.api.delete(`/discountModels/${id}`).then((response) => response.data);
    },
    checkDiscountModel: (body) => {
        return axios.api.post("/discountModels/checkDiscount", body).then((response) => response.data);
    }
};
